import React from 'react';
import { getDisplayedHelpTexts, getForceHideHelpText, updateForceHideHelpText } from '@soulhx/client-store';
import { Form, Stack } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { SHXButton } from '@soulhx/ui-common';
import { useTranslation } from 'react-i18next';

export const useHideHelpTextBtn = (): boolean => {
  const displayedHTs = useSelector(getDisplayedHelpTexts);

  return displayedHTs.length > 0;
};

export const HideHelpText = () => {
  const forceHide = useSelector(getForceHideHelpText);
  const dispatch = useDispatch();
  const { t } = useTranslation(['comms']);
  const showComponent = useHideHelpTextBtn();

  if (!showComponent) return null;

  return (
    <Stack gap={1} className="mb-5">
      {!forceHide && (
        <>
          <p>
            <Form.Text>{t('comms:serverMessages.hideAllHTBtnText')}</Form.Text>
          </p>
          <SHXButton
            variant="warning"
            onClick={() => {
              dispatch(updateForceHideHelpText(true));
            }}
          >
            {t('comms:serverMessages.hideAllHTBtn')}
          </SHXButton>
        </>
      )}

      {forceHide && (
        <SHXButton
          variant="success"
          onClick={() => {
            dispatch(updateForceHideHelpText(false));
          }}
        >
          {t('comms:serverMessages.showHTBtn')}
        </SHXButton>
      )}
    </Stack>
  );
};
